/**
 * Google Translate rewrites text nodes directly, outside React's knowledge.
 * React then tries to remove or reorder nodes that are no longer where its
 * virtual tree believes them to be, and throws:
 *
 *   Failed to execute 'removeChild' on 'Node'
 *
 * These guards make the two offending methods no-op instead of throwing when
 * the node has already been moved. Workaround from facebook/react#11538.
 *
 * Must be imported before React mounts.
 */
export const installDomGuards = () => {
  if (typeof Node !== "function" || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child) {
    if (child.parentNode !== this) return child;
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) return newNode;
    return originalInsertBefore.apply(this, arguments);
  };
};
